import { PrismicRichText } from "@prismicio/react";
import Check from "@/components/svg/Check";

const blogTextComponents = ({ weight = null } = {}) => ({
  paragraph: ({ children }) => <p className={`text-bleu p-blog ${weight}`}>{children}</p>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
});

/**
 * @typedef {import("@prismicio/client").Content.BlogSliceKeyPointsPrimary} KeyPointsPrimary
 * @param {{ primary: KeyPointsPrimary }} props
 */
const KeyPoints = ({ primary }) => (
  <div className="flex flex-col gap-[30px] bg-vert-10 py-10 px-[30px] rounded-[20px]">
    <PrismicRichText
      field={primary.title}
      components={{
        heading2: ({ children }) => <h2 className="h2-n lg:dk md text-bleu">{children}</h2>,
      }}
    />
    <div className="flex flex-col gap-5">
      {primary.key_points.map((keyPoint, index) => (
        <div key={index} className="flex flex-row items-start justify-start gap-3">
          <Check />
          <PrismicRichText field={keyPoint.key_point} components={blogTextComponents()} />
        </div>
      ))}
    </div>
  </div>
);

export default KeyPoints;
